import React, {useEffect, useState} from "react";

import Contact from '../../media/images/Contact.svg';
import WhatsApp from '../../media/images/Whatsapp.svg';
import LinkImage from '../../media/images/Link.svg';
import MailIcon from '../../media/images/IconMail.svg';
import DeliveryIcon from '../../media/images/DeliveryIcon.svg';


import {Link, useSearchParams} from 'react-router-dom';
import Header from '../Header';

import {frontendBaseURL, mainRolesRoutes} from "../../global";

import {Alert, Collapse, IconButton, Typography} from '@mui/material';
import Modal from 'react-bootstrap/Modal';

import {WhatsappShareButton, EmailShareButton} from "react-share";
import dataProvider from "../../provider/api-interface";

import '../../App.css';
import './Wishlist.css';

import { useTranslation, withTranslation } from 'react-i18next';
import {useNavigate} from "react-router";

import CloseIcon from "@mui/icons-material/Close";

import {decode} from "html-entities";
import SearchBar from "../search-engine/SearchBar";
import {useCabanaContext} from "../CabanaContext";
import {Loader} from "../Loader";
import dayjs from "dayjs";
import {useAnalytics} from "../../hook/useAnalytics";

function Wishlist() {
    const { t } = useTranslation();
    const {
        jwtToken,
        user,
        userType,
        wishlist,
        isLoadingWishlist,
        listCode
    } = useCabanaContext();

    const navigate = useNavigate();

    const [showModal, setShowModal] = useState(false);
    const [isLoading] = useState<boolean>(true);
    const [wishlistUrl, setWishlistUrl] = useState<string>(window.location.href);

    const [productsListClass, setProductsListClass] = useState<string>('col-12 col-lg-6');

    const handleClose = () => setShowModal(false);
    //End use anywhere

    const [searchParams] = useSearchParams();
    const [query, setQuery] = useState<any>('');
    const [activeFilters] = useState<any>(searchParams.get('filter'));
    const [products, setProducts] = useState<any>(null);

    const [notificationText, setNotificationText] = useState<string>('');
    const [notificationType, setNotificationType] = useState<any>("info");
    const [notificationOpen, setNotificationOpen] = useState(false);
    const { trackEvent } = useAnalytics();
    const autoClose = () => {
        setTimeout(() => {
            setNotificationOpen(false);
        }, 3000);
    };

    useEffect(() => {
        if(products !== null) {
            setProductsListClass('col-12 col-lg-9');
        }
    }, [products]);


    useEffect(() => {
        if(wishlist !== null){
            const fetchAllProducts = async () => {
                let filterSort: any = {
                    filter: "",
                    sort: "",
                    search: "",
                };

                let queryString = (query === '') ? `?filter={"wishlist_id": "${wishlist.id}"${filterSort.filter}${filterSort.search}}&perPage=-1` : query;

                try {
                    const response = await dataProvider.get(`product/${queryString}`, jwtToken);
                    if (response !== null) {
                        if(userType === 'giftee'){
                            setWishlistUrl(frontendBaseURL + '/' + mainRolesRoutes.gifter + '/registry/' + wishlist.list_code);
                        }
                        setProducts(response);
                    } else {
                        console.log("Errore nel recupero dei prodotti");
                    }
                } catch (error: any) {
                    console.error("Errore nella richiesta API:", error);
                    if(error.status === 401){
                        navigate('/login');
                    }
                }
            };

            fetchAllProducts().then(() => {});
        }
    }, [query, wishlist]);

    const updateQuery = (newQuery: any) => {
        setQuery(newQuery)
    };

    if(user === null || isLoadingWishlist || products === null){
        return <div style={{height: "100vh", width: "100%"}}><Loader/></div>;
    }

    const addItemsButton = () => {
        if(userType !== 'gifter') {
            if(wishlist.products === null) {
                return (
                    <Link to={`/${userType}/registry/categories?id=${wishlist?.list_code}`} className="Fgift-button Fgift-wl-buttons">
                        {t("noProductsButton")}
                    </Link>
                );
            }

            return (
                <Link to={`/${userType}/registry/categories?id=${wishlist?.list_code}`} className="Fgift-button Fgift-wl-buttons">
                    {t("addItemFromCatalogue")}
                </Link>
            )
        }

        return null;

    }

    const shareModal= () => {
        if(wishlist === null) {
            return null;
        }

        let shareParagraph = t('modalShareParagraphSA');
        let whatsappShare: any = null;
        let emailShare: any = null;
        let cols = "col-6";

        let message: any = `${t('shareText')}\n\n${t('hereTheLink')}`;
        if(userType === 'giftee') {
            shareParagraph = t('modalShareParagraphGIFTEE');
            cols = "col-3";
            whatsappShare = <div className={cols}>
                <WhatsappShareButton
                    url={`${wishlistUrl}?utm_source=social`}
                    title={message}
                    onClick={() => {
                        trackEvent("share_registry", {
                            category: "cabana_event",
                            label: "The user shares his gift list with others",
                            user_id: user.id,
                            giftee_id: user.id,
                            registry_id: listCode,
                            share_method: 'social',
                        });
                    }}
                >
                    <div className="WishlistSocialShareIcons" style={{cursor: 'pointer'}}>
                        <img id="whatsapp-share-button" src={WhatsApp} alt="social share icon" style={{height: '48px', width: '48px'}} /><span>WhatsApp</span>
                    </div>
                </WhatsappShareButton>
            </div>;

            emailShare = <div className={cols}

            >
                <EmailShareButton
                    url={`${wishlistUrl}?utm_source=email`}
                    subject={'Wedding Gift List - ' + wishlist.name}
                    body={t('shareText')}
                    beforeOnClick={() => {
                        trackEvent("share_registry", {
                            category: "cabana_event",
                            label: "The user shares his gift list with others",
                            user_id: user.id,
                            giftee_id: user.id,
                            registry_id: listCode,
                            share_method: 'email',
                        });
                    }}
                >
                    <div className="WishlistSocialShareIcons" style={{cursor: 'pointer'}}>
                        <img id="email-share-button" src={MailIcon} alt="social share icon" style={{height: '48px', width: '48px'}} /><span>E-mail</span>
                    </div>
                </EmailShareButton>
            </div>;
        }


        let gapStyle = {gap: '0px'};
        if(userType === 'giftee'){
            gapStyle = {gap: '15px'};
        }
        return (<Modal className="ShareModal right" show={showModal} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{t('modalShareTitle')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{fontSize: '13px'}}>{shareParagraph}</div>
                <div id="share-buttons" className="row ShareIcons" style={gapStyle}>
                    {whatsappShare}
                    {/*facebookShare*/}
                    {emailShare}
                    <div className={cols}>
                        <div className="WishlistSocialShareIcons" style={{cursor: 'pointer'}}  onClick={() => {
                            trackEvent("share_registry", {
                                category: "cabana_event",
                                label: "The user shares his gift list with others",
                                user_id: user.id,
                                giftee_id: user.id,
                                registry_id: listCode,
                                share_method: 'copy_link',
                            });
                            let copyMessage = `${wishlistUrl}?utm_source=copy_link`;

                            navigator.clipboard.writeText(copyMessage).then(() => {});
                            setShowModal(false);
                            setNotificationType('info');
                            setNotificationText(t('wishlistUrlCopied'));
                            setNotificationOpen(true);
                            autoClose();
                        }}>
                            <img id="copy-share-button" src={LinkImage} alt="social share icon" style={{height: '48px', width: '48px'}} /><span>{t('copyLinkButton')}</span>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>)
    }

    const setHeader = () => {


        if(wishlist === null) {
            return <Header hideLanguageSelect={true}></Header>;
        }

        return (
            <Header hideLanguageSelect={true}></Header>
        );

    }

    if(wishlist == null) {
        return (
            <div>
                {setHeader()}
                {/*getLoader()*/}
            </div>
        )
    }

    const renderWishlist = (): JSX.Element => {
        if(wishlist !== null) {
            if (products === null) {
                return (
                    <div className="NoProducts">
                        <div className="NoProductsText">{t('noProductsFound')}</div>
                        <div className="NoProductsSubtitle">{t('noProductsSubtitle')}</div>
                    </div>
                );
            } else {
                return (
                    <SearchBar
                        products={products}
                        wishlist={wishlist}
                        locale={1}
                        isLoading={isLoading}
                        routeType={'wishlist'}
                        searchQuery={'products'}
                        activeFilters={activeFilters}
                        setQuery={updateQuery}
                        setFilters={() => {}}
                        setImagesLoaded={() => {}}
                        token={jwtToken} />
                );
            }
        } else {
            return (
                <div className="NoProducts">
                    <div className="NoProductsText">{t('noProductsFound')}</div>
                    <div className="NoProductsSubtitle">{t('noProductsSubtitle')}</div>
                </div>
            );
        }
    };

    const handleShare = async () => {
        if(wishlist !== null) {
            setShowModal(true)
        }
    }

    const renderWishlistText = () => {
        let wishlistText = t('wishlistText');

        if(user.role === 2) {
            return <div className="WishlistText align-items-lg-center">
                <p style={{marginBottom: '-24px'}}>{wishlistText}</p>
            </div>
        }

        return '';
    }

    const wishlistContactButton = () => {
        let phoneNumber = '+39 (0) 27423 5292';
        let sanitizedPhoneNumber = phoneNumber.replace(/[^0-9]/g, '');

        let contactNumber = `https://wa.me/${sanitizedPhoneNumber}`;

        let contactButton = <Link className="WishlistSocialShareButton"  to={contactNumber} >
                <img src={Contact} alt="social share icon" style={{height: '20px', width: '20px', paddingRight: '3px'}} /><span className="ShareText">{t('contactText')}</span>
            </Link>;


        return <div className="ShareContainer">
            {contactButton}
        </div>
    }

    const editWishlistButton = () => {
        let editButton: any = '';
        if(user.role === 1 && (wishlist.delivery_address_line_1 !== null || parseInt(wishlist.choiced_pickup_option) === 1)) {
            editButton = <Link to={`/giftee/registry/${wishlist.list_code}/edit`} style={{marginLeft: '6px'}} className="WishlistSocialShareButton">
                <img src={DeliveryIcon} alt="delivery icon" style={{height: '20px', width: '20px', paddingRight: '3px'}} /><span className="ShareText">Delivery details</span>
            </Link>
        }

        return editButton;
    }

    const WishlistShareOrDelivery: React.FC<{wishlist: any}> = ({
                                                                    wishlist}) => {
        if (user.role !== 1) return null;

        if(wishlist.delivery_address_line_1 === null && parseInt(wishlist.choiced_pickup_option) !== 1){
            return (
                <Link to={`/giftee/registry/${wishlist.list_code}/edit`} className="Fgift-button AddDeliveryInfo Fgift-button-reverted Fgift-wl-buttons">
                    Add delivery<br/> information
                </Link>
            );
        }else{
            return (
                <div className="Fgift-button Fgift-button-reverted Fgift-wl-buttons" onClick={() => {handleShare().then(() => {})}}>
                    {t('shareButton')}
                </div>
            )
        }
    }

    return (
        <div>
            {setHeader()}
            <div className="row WishlistDates d-flex d-lg-none">
                <div className="col-12 DatesContainer">
                    <div className="WishlistDateContainer">
                        <p style={{fontWeight: '700'}}>{t('startDate') + ': ' + dayjs(wishlist.event_date).format('DD/MM/YYYY')}</p>
                    </div>
                    <div className="WishlistDateContainer">
                        <p>{t('endDate') + ': ' + dayjs(wishlist.end_date).format('DD/MM/YYYY')}</p>
                    </div>
                </div>
            </div>
            <div className="WishlistHeader">
                <div className="row">
                    <div className="col-12">
                        <div className="WishlistTitleContainer">
                            <Typography
                                className={'wishlist-header-title'}
                            >
                                {decode(wishlist.name)}
                            </Typography>
                        </div>
                    </div>
                    <div className="col-12">
                        <Typography
                            className={'wishlist-header-created-by'}
                        >
                            {t('createdBy')}: {wishlist.giftee.name} {wishlist.giftee.surname}
                        </Typography>
                    </div>
                    <div className="col-12">
                        <div className="WishlistSocialShareContainer">
                            {editWishlistButton()}
                        </div>
                    </div>
                </div>
            </div>
            {renderWishlistText()}
            <div className="WishlistItemsContainer row px-lg-4">
                <div className="col-3 d-none d-lg-flex flex-column justify-content-center align-items-start">
                    <div className="WishlistDesktopDates">
                        <div className="WishlistDateContainer">
                            <p style={{fontWeight: '700'}}>{t('startDate') + ': ' + dayjs(wishlist.event_date).format('DD/MM/YYYY')}</p>
                        </div>
                        <div className="WishlistDateContainer">
                            <p>{t('endDate') + ': ' + dayjs(wishlist.end_date).format('DD/MM/YYYY')}</p>
                        </div>
                    </div>
                    <div className="ButtonContainer d-none flex-column align-items-baseline gap-3 cursor-pointer d-lg-flex position-relative"
                         style={{width: '80%', marginLeft: '48px'}}>
                        {addItemsButton()}
                        <WishlistShareOrDelivery wishlist={wishlist} />
                    </div>
                </div>
                <div className={productsListClass}>
                    <Collapse className="FgiftCustomCollapse" in={notificationOpen}>
                        <Alert
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setNotificationOpen(false);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                            severity={notificationType}
                        >
                            {notificationText}
                        </Alert>
                    </Collapse>
                    {renderWishlist()}
                </div>
                <div className="col-3 d-none d-lg-flex"></div>
            </div>
            <div className="ButtonContainer d-flex flex-column gap-3 d-lg-none">
                {addItemsButton()}
                <WishlistShareOrDelivery wishlist={wishlist} />
            </div>
            {shareModal()}
        </div>
    )



}

export default withTranslation()(Wishlist);